import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ClientDiagnosticsService } from '../services';

/**
 * Records any 4xx/5xx HTTP response into ClientDiagnosticsService so the
 * bug report dialog can attach the most recent failure as `clientContext`
 * — without the user needing to describe what went wrong.
 *
 * The bug report POST itself is excluded to avoid recording the
 * submission attempt into the snapshot it would carry.
 *
 * This interceptor does NOT swallow errors — `throwError` re-throws so
 * downstream handlers still see the original response.
 */
@Injectable()
export class ErrorRecordingInterceptor implements HttpInterceptor {
  private readonly diagnostics = inject(ClientDiagnosticsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip every bug-report endpoint — the customer POST so we don't record
    // the submission into its own clientContext, AND the admin reads/PATCH
    // so an admin triaging reports doesn't leak their own tooling errors
    // into a customer's diagnostic trail on their next submission.
    if (req.url.includes('/bug-reports')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          this.diagnostics.recordHttpError(req.method, req.urlWithParams, err.status, err.error);
        }
        return throwError(() => err);
      }),
    );
  }
}
